export default __webpack_public_path__ + "static/char-36-anr-967852d5eea03cd1beacdbc2c94d9161.gif";